import { viewToCollabJSON } from '@databases/collab/convert/to-collab';
import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setSavedView: YJSChangeHandler<DatabaseChangeType.SET_SAVED_VIEW> = ({
  ydb,
  change,
}) => {
  ydb.mutate((db) => {
    db.setView(change.view.id, viewToCollabJSON(change.view, {}));
  });
};
